export default __webpack_public_path__ + "static/media/download-guide-bg.8fd5294f.webp";